import { Brand } from "../../../shared/model/brand.model";
import { Country } from "../../../shared/model/country.model";
import { Region } from "../../../shared/model/region.model";
import { Contact } from "../../users/model/user.model";

export const getEmptyGroup = (): DistributionListGroup => ({
  id: '',
  name: '',
  brand: {code: '', description: '', logo: ''},
  distributionList: [],
  region: {code: '', description: ''},
  countries: [],
});
export interface DistributionListGroup {
  id: string;
  name: string;
  brand: Brand;
  distributionList: Contact[];
  region: Region;
  countries: Country[];
}


export interface DistributionListGroupFilters {
  brands: string[];
  regions: string[];
  countries: Country[];
}

export const emptyDistributionListGroupFilters = {
  brands: [],
  regions: [],
  countries: [],
};
export interface DistributionListGroupResponse {
    id: string;
    name: string;
    brand: Brand;
    distributionList: Contact[];
    region: Region;
    countries: Country[];
  }

export interface DistributionListGroupCreationRequest {
  name: string;
  brand: Brand;
  distributionList: Contact[];
  region: Region;
  countries: Country[];
}

export interface DistributionListGroupUpdateRequest {
  name: string;
  brand: Brand;
  distributionList: Contact[];
  region: Region;
  countries: Country[];
}


export const toDistributionListGroup = (response: DistributionListGroupResponse): DistributionListGroup => ({
  id: response.id,
  name: response.name,
  brand: response.brand,
  distributionList: response.distributionList,
  region: response.region,
  countries: response.countries,
});
